module.exports = "https://cdn-shared.mathletics.com/teacher-modules/upf-assign/75/assets/images/99a7236f0c6da61df0520defc3b7c16c.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_gem_2.svg
// module id = l+aX
// module chunks = 0